import { IHtmlTextsApi } from "./IHtmlTextsApi";
import { IResult } from "../../../Models/Result/IResult";
import { IHtmlTextItem } from "../../../Models/HtmlTexts/IHtmlTextItem";
import { IHtmlText } from "../../../Models/HtmlTexts/IHtmlText";
import { formatUrl, handleError } from "../ApiHelpers";
import axios from 'axios';
import { Result } from "../../../Models/Result/Result";

export class HtmlTextsApi implements IHtmlTextsApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getHtmlTextsPaths(): Promise<IResult<string[]>> {

        try {
            const url = formatUrl(this.backendUrl, `/api/HtmlEdit/HtmlTextsPaths`);
            const response = await axios.get(url);
            return response.data as IResult<string[]>;
        }
        catch (error) {
            return handleError(error, "getHtmlTextsPaths");
        }
    }

    async saveHtmlText(path: string, name: string, title: string, text: string): Promise<IResult<boolean>> {
        try {
            var bodyFormData = new FormData();
            bodyFormData.append('text.path', path);
            bodyFormData.append('text.name', name);
            bodyFormData.append('text.title', title);
            bodyFormData.append('text.text', text);
            const url = formatUrl(this.backendUrl, `/api/HtmlEdit/SaveText`);
            const response = await axios.post(url, bodyFormData);
            return Result.ok(true);
        }
        catch (error) {
            return handleError(error, "saveHtmlText");
        }
    }

    async getHtmlTexts(path?: string): Promise<IResult<IHtmlTextItem[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/HtmlEdit/HtmlTextsByPath/${path ? path:""}`);
            const response = await axios.get(url);
            return response.data as IResult<IHtmlTextItem[]>;
        }
        catch (error) {
            return handleError(error, "getHtmlTexts");
        }
    }

    async getHtmlText(path: string, name: string): Promise<IResult<IHtmlText>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/HtmlEdit/HtmlText?path=${path}&name=${name}`);
            const response = await axios.get(url);
            return response.data as IResult<IHtmlText>;
        }
        catch (error) {
            return handleError(error, "getHtmlText");
        }
    }
}